import "./Form.css"
import { useEffect, useState } from "react";
import FormTextInput from "./FormTextInput";
import SVGS from "./svgs/SVGS";
import FormService from "../services/formService";
import { BUTTON_TEXT, DEFAULT_FORM_SETTINGS, ERROR } from "./consts.jsx";
import Button from "./Button/Index";
import Section from "./Section";
import SecondaryTitle from "./Section/SecondaryTitle";
import Paste from "./Paste";
import Error from "./Error";

const BotzappingForm = ({ initSettings }) => {
  const [settings, setSettings] = useState(DEFAULT_FORM_SETTINGS);
  const [showTooltip, setShowTooltip] = useState(false);
  const [authButtonText, setAuthButtonText] = useState(BUTTON_TEXT.ACTIVATE);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const { LogoSVG, StripsSVG, ClipBoardSVG } = SVGS();
  const clearErrorMessage = () => errorMessage && setErrorMessage(null)
  const [secondaryButtonText, setSecondaryButtonText] = useState(null)
  const formService = new FormService();
  const settingsFilled = settings.authKey && settings.domainKey && settings.secretKey;

  const setActivate = () => {
    setAuthButtonText(BUTTON_TEXT.ACTIVATE)
    setSecondaryButtonText(null)
  }

  const setActivated = () => {
    setAuthButtonText(BUTTON_TEXT.ACTIVATED)
    setSecondaryButtonText(BUTTON_TEXT.DEACTIVATE)
  }

  const toggleSuccess = () => {
    setAuthButtonText(BUTTON_TEXT.SUCCESS)
    setTimeout(setActivated, 1000)
  }

  const toggleDeactivated = () => {
    setAuthButtonText(BUTTON_TEXT.DEACTIVATED)
    setTimeout(setActivate, 1000)
  }

  const setError = (error) => {
    setErrorMessage(error || ERROR.BOTZAPPING_ACTIVATION); 
    setAuthButtonText(BUTTON_TEXT.ERROR)
    setSecondaryButtonText(BUTTON_TEXT.TRY_AGAIN)
  }

  const setActivating = () => {
    clearErrorMessage()
    setAuthButtonText(BUTTON_TEXT.ACTIVATING)
  }

  const deactivate = async () => {
    const response = await formService.updateKeys({ deactivate: true })
    if(response)
        setError(response)
    else{
      settings.botzappingAuth = false
      setSettings({ ...settings })
      toggleDeactivated()
    }
  }

  const authenticate = async (e) => {
    setLoading(true)  
    if (settingsFilled) { 
      setActivating()         
      const response = await formService.updateKeys(settings)
      if(response)
        setError(response)
      else{
        settings.botzappingAuth = !response;
        setSettings({ ...settings });
        toggleSuccess()
      }      
    }    
    setLoading(false);
  };
  
  const showErrorTooltip = () => {
    setShowTooltip(true)
    setTimeout(() => setShowTooltip(false), 1000)
  }

  const pasteAll = async (e) => {
    try{
      const clipboardContents = await navigator.clipboard.readText()
      const keys = JSON.parse(clipboardContents)
      if(keys.authKey && keys.domainKey && keys.secretKey){
        setSettings(keys);
        setAuthButtonText(BUTTON_TEXT.ACTIVATE)
      }
      else
        showErrorTooltip()
    }
    catch(error){
      showErrorTooltip()
    }
  }  

  useEffect(() => {
    if(initSettings){
      setSettings(initSettings);
      if(initSettings.botzappingAuth)
        setActivated()
    }   
  }, [initSettings]);

  const body = <>
    <div className="form-title">
      <span>Installation keys</span>
      <Paste onClick={pasteAll} visible={showTooltip} icon={<ClipBoardSVG/>}/>     
    </div>
    <FormTextInput
      placeholder={"Domain Key"}
      value={settings.domainKey}
      setValueCB={(value) => {
        settings.domainKey = value;
        setSettings({ ...settings });
      }}
    ></FormTextInput>
    <FormTextInput
      placeholder={"Secret Key"}
      value={settings.secretKey}
      setValueCB={(value) => {
        settings.secretKey = value;
        setSettings({ ...settings });
      }}
    ></FormTextInput>
    <FormTextInput
      placeholder={"Authentication Key"}
      value={settings.authKey}
      setValueCB={(value) => {
        settings.authKey = value;
        setSettings({ ...settings });
      }}
    ></FormTextInput>
    <section className="cc-flex-column">
      <Error text={errorMessage}/>
      <section className="cc-flex">
        <Button 
          disabled={!settingsFilled}
          onClick={authenticate}
          loading={loading}
          content={authButtonText}
        />
        { 
          secondaryButtonText &&
          <Button 
            onClick={secondaryButtonText === BUTTON_TEXT.DEACTIVATE ? deactivate : authenticate}
            content={secondaryButtonText} 
          />
        }           
      </section>
    </section>                            
  </>

  const secondaryTitle = <SecondaryTitle checked={settings.botzappingAuth} text="Authentication" />  

  return (
    <>
      <header className="main-header">
        <LogoSVG></LogoSVG>
        <StripsSVG></StripsSVG>
      </header>      
      <Section title="Bot Zapping" secondaryTitle={secondaryTitle} body={body} />         
    </>
  );
};

export default BotzappingForm;
